
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Use a more efficient way to create the root
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

// Add event listener with passive option for better performance
document.addEventListener('touchstart', function() {}, { passive: true });
document.addEventListener('wheel', function() {}, { passive: true });

// Force reloading assets in development mode
if (import.meta.env.DEV) {
  // Add a timestamp to force browser to reload assets
  const timestamp = new Date().getTime();
  const meta = document.createElement('meta');
  meta.setAttribute('name', 'cache-control');
  meta.setAttribute('content', `no-cache, no-store, must-revalidate, max-age=0, s-maxage=0, timestamp=${timestamp}`);
  document.head.appendChild(meta);
}

// Render the app
root.render(<App />);
